export default __webpack_public_path__ + "static/media/piper-bed-crop.25039fa9.jpg";